module.exports = __webpack_public_path__ + "media/images/my_apps/atlas_2022_icon-bd202e2b4c6f5a984e218e766ebee976.png";